import { atom } from 'jotai';

export const pickerModeAtom = atom<'add' | 'replace' | undefined>(undefined);
